const selectedBrands = ["scotch-and-soda", "asics", "mason-garments"];

export const isIncludedInSelectedBrands = (path: string): boolean =>
  selectedBrands.some((brand) => path.includes(brand));
